<script setup lang="ts">
const router = useRoute();
const documentId = router.params.documentId as string;
const revisionId = router.params.revisionId as string;
</script>

<template>
  <ChecklistPDFGenerator :document-id="documentId" :revision-id="revisionId" />
</template>

<style scoped></style>
